import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Intro from "../pages/intro/page";
import Onboarding from "../pages/onboarding/page";
import Home from "../pages/home/page";
import Yangbok from "../pages/yangbok/page";
import Guide from "../pages/guide/page";
import Diagnose from "../pages/diagnose/page";
import Result from "../pages/result/page";
import Vendors from "../pages/vendors/page";
import VendorDetail from "../pages/vendorDetail/page";
import Reviews from "../pages/reviews/page";
import Quote from "../pages/quote/page";
import Quotes from "../pages/quotes/page";
import My from "../pages/my/page";
import YangbokPage from "@/pages/YangbokOrg/page";
import YangbokForm from "@/pages/YangbokOrg/YangbokForm";
import Form from "@/pages/YangbokOrg/Form";
import QuestionResult from "@/pages/YangbokOrg/QuestionResult";
import YangbokListPage from "@/pages/YangbokOrg/YangbokListPage";
import YangbokDetailPage from "@/pages/YangbokOrg/YangbokDetailPage";
import YangbokQuestionResultPage from "@/pages/YangbokOrg/result/YangbokQuestionResultPage";
import YangbokV5TestPage from "@/pages/yangbok-v5/test/page";
import PhotosPage, { PhotosDrawer } from "@/pages/yangbok-v5/test/photos/page";
import LookbookPage from "@/pages/yangbok-v5/test/lookbook/page";
import ReviewsPage from "@/pages/yangbok-v5/test/reviews/page";
import PartnerShopPreviewPage from "@/pages/yangbok-v5/test/PartnerShopPreviewPage";
import PartnerShopListPage from "@/pages/shop-list/Page";
import Main4Page from "@/pages/main/page";
import AppLayout from "@/components/AppLayout";
// import GuideHub from "@/pages/guide/hub";
import NewGuidePage from "@/pages/NewGuide/page";
import ShopList from "@/pages/list/page";
import PartnerShopDetail from "@/pages/detail/page";
import GuideCategoryPage from "@/pages/guide/category/page";
import GuideCategoryResultPage from "@/pages/guide/category/result/page";
import GuideHub from "@/pages/guide/page";
import PrivacyTermPage from "@/pages/terms/PrivacyTermPage";
import UserTermPage from "@/pages/terms/UserTermPage";



export const LIST_PATHS = {
  SUIT: '/shops/suit',
  JEWELRY: '/shops/jewelry',
  HANBOK: '/shops/hanbok'
}

export const SHOPS_LIST = [
  '/shops/suit',
  '/shops/jewelry',
  '/shops/hanbok'
]

export const GUIDE_HUB_PATH = '/guide'

const routes: RouteObject[] = [
  {
    element: <AppLayout />,
    children: [
      {
        path: "/",
        element: <Home />,
      },
      {
        path: "/shops/:categoryKey",
        element: <ShopList />
        // element: <PartnerShopListPage />,
      },
      {
        path: '/detail/:shopSlug',
        element: <PartnerShopDetail />,
      },
      {
        path: '/detail/:shopSlug/reviews',
        element: <PartnerShopDetail />,
      },
      {
        path: '/detail/:shopSlug/review-photos',
        element: <PartnerShopDetail />,
      },
      {
        path: '/detail/:shopSlug/review-photos/:imageId',
        element: <PartnerShopDetail />,
      },
      {
        path: '/guide/:category',
        element: <GuideCategoryPage />
      },
      // {
      //   path: '/detail/:shopSlug',
      //   element: <YangbokV5TestPage />,
      //   children: [
      //     {
      //       path: "photos",
      //       element: <PhotosDrawer />
      //     }
      //   ]

      // },
      // // {
      // //   path: '/detail/:shopSlug/photos',
      // //   element: <PhotosPage />
      // // },
      // {
      //   path: '/detail/:shopSlug/lookbook',
      //   element: <LookbookPage />
      // },
      // {
      //   path: '/detail/:shopSlug/reviews',
      //   element: <ReviewsPage />
      // },
      {
        path: '/guide',
        element: <GuideHub />
      },
      {
        path: '/guide/:category/result/:resultKey',
        element: <GuideCategoryResultPage />
      },
      {
        path: '/terms/privacy',
        element: <PrivacyTermPage />
      },
      {
        path: '/terms/user-term',
        element: <UserTermPage />
      },
      // {
      //   path: '/guide/suit',
      //   element: <Form />
      // },
      // {
      //   path: "/guide/:category",
      //   element: <NewGuidePage />,
      // },
      // {
      //   path: "/diagnose/:category",
      //   element: <Diagnose />,
      // },
      // {
      //   path: "/result/:category",
      //   element: <Result />,
      // },
      
    ]
  },
  // {
  //   path: "/onboarding",
  //   element: <Onboarding />,
  // },
  // {
  //   path: "/home",
  //   element: <Home />,
  // },
  // {
  //   path: "/yangbok-readdy",
  //   element: <YangbokPage />,
  // },
  // // {
  // //   path: "/",
  // //   element: <Form />,
  // // },
  // // {
  // //   path: "/list",
  // //   element: <PartnerShopListPage />,
  // // },
  // {
  //   path: '/result',
  //   element: <QuestionResult />
  // },
  // {
  //   path: '/guide/:category/result/:resultKey',
  //   element: <YangbokQuestionResultPage />
  // },
  // {
  //   path: '/yangbok/list',
  //   element: <YangbokListPage />
  // },
  // {
  //   path: '/yangbok/detail/test',
  //   element: <YangbokDetailPage />
  // },
  
  // {
  //   path: "/yangbok",
  //   element: <YangbokForm />,
  // },
  // {
  //   path: "/yangbok/preview",
  //   element: <PartnerShopPreviewPage />,
  // },
  
  
  // {
  //   path: "/vendors",
  //   element: <Vendors />,
  // },
  // {
  //   path: "/vendor/:id",
  //   element: <VendorDetail />,
  // },
  // {
  //   path: "/reviews",
  //   element: <Reviews />,
  // },
  // {
  //   path: "/quote",
  //   element: <Quote />,
  // },
  // {
  //   path: "/quotes",
  //   element: <Quotes />,
  // },
  // {
  //   path: "/my",
  //   element: <My />,
  // },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;
